import { render, staticRenderFns } from "./systemTip.vue?vue&type=template&id=7cf535a2&scoped=true&"
import script from "./systemTip.vue?vue&type=script&lang=js&"
export * from "./systemTip.vue?vue&type=script&lang=js&"
import style0 from "./systemTip.vue?vue&type=style&index=0&id=7cf535a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf535a2",
  null
  
)

export default component.exports